import { useMemo } from 'react';
export const useNotificationsQueryKey = () => {
    return useMemo(() => ['notifications'], []);
};
